import React, { useState, useEffect } from "react";
import StudentDashboardLayout from "./StudentDashboardLayout";
import { getMyMarksAPI } from "../../utils/Api";

const ViewMarks = () => {
  const [marks, setMarks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMarks = async () => {
      try {
        const response = await getMyMarksAPI();
        setMarks(response.data.marks);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch marks");
      } finally {
        setLoading(false);
      }
    };
    fetchMarks();
  }, []);

  return (
    <StudentDashboardLayout>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6">
        <h1 className="text-3xl font-bold mb-6">My Marks</h1>
        {loading && <p>Loading marks...</p>}
        {error && <p className="text-red-500">{error}</p>}
        {!loading && !error && (
          <div className="grid grid-cols-1 gap-6">
            {marks.map((subject) => (
              <div key={subject.subjectCode} className="p-4 border rounded-lg">
                <h2 className="text-xl font-bold mb-2">
                  {subject.subjectName}
                </h2>
                <p className="text-gray-600 mb-4">
                  Code: {subject.subjectCode}
                </p>
                <table className="w-full text-left">
                  <thead>
                    <tr>
                      <th className="font-semibold">Component</th>
                      <th className="font-semibold">Marks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subject.marks.map((mark) => (
                      <tr key={mark.schemeName}>
                        <td>{mark.schemeName}</td>
                        <td>{mark.obtainedMarks}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-4 pt-2 border-t">
                  <p className="font-bold">
                    Total: {subject.totalObtained} / {subject.totalMaximum}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </StudentDashboardLayout>
  );
};

export default ViewMarks;
